import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';
import { ThemeSettings } from 'Constants/Theme';

export class MenuShow extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const renderable: Renderable = gameObject.getComponent(Renderable);
        const element: ElementComponent = gameObject.getComponent(
            ElementComponent
        );

        renderable.visible = true;
        element.anchors = [0, 1, 1, 2];

        const moveUpTween: Tween = this.getTween(element);

        moveUpTween
            .to({ anchorX1: 0, anchorY1: 0, anchorX2: 1, anchorY2: 1 }, 500)
            .easing(ThemeSettings.MENU_SHOW_EASING);

        yield* this.startTween(moveUpTween);
    }
}
